import { apiClient } from './client'
import endpoints from './endpoints'

export default async function deleteMetric(
  metricId,
  dataCollectionStatementId,
  reasonComment,
  userRole,
) {
  const response = await apiClient.delete(`${endpoints.metricEvents}/${metricId}`, {
    params: { userRole },
    data: { dataCollectionStatementId, reasonComment },
  })
  return response.data
}
